// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".token-info[data-v-50f77400] {\n  background-color: #F7F7F7;\n  border-radius: 0.25rem;\n  padding: 1rem 1.5rem;\n  margin-bottom: 1rem;\n}\n.token-info .label[data-v-50f77400] {\n  display: block;\n  font-size: 0.875rem;\n  color: #727272;\n}\n.token-info .info[data-v-50f77400] {\n  color: #11291B;\n}\n.token-info .separator[data-v-50f77400] {\n  border-bottom: 1px solid #DEDEDE;\n  margin: 1rem 0rem;\n}", ""]);
// Exports
module.exports = exports;
